import { Button, UIText1 } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { TWithModalProps } from 'shared/common/types/components';
import { EModalSource } from 'shared/common/types/modal';

type THelpYouSellProps = TWithModalProps;

export const getUTP = (onOpenQualityCriteriaModal: () => void) => [
  {
    title: (
      <span>
        Выбрали лучших агентов по&nbsp;своим&nbsp;
        <span
          className={style['clickable-text']}
          onClick={onOpenQualityCriteriaModal}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              onOpenQualityCriteriaModal();
            }
          }}
        >
          критериям качества
        </span>
      </span>
    ),
    imageClass: 'photos',
  },
  {
    title: 'Ваш объект увидит максимум покупателей',
    imageClass: 'duck',
  },
  {
    // eslint-disable-next-line no-irregular-whitespace
    title: <span>Без предоплат и скрытых комиссий</span>,
    imageClass: 'umbrella',
  },
];

const CardMobile = ({ text, imageClass }: { text: React.ReactNode; imageClass: string }) => {
  return (
    <div className={style['card-mobile']}>
      <div className={clsx(style['item-image'], style[imageClass])} />
      <UIText1 color="text-inverted-default">{text}</UIText1>
    </div>
  );
};

const CardDesktop = ({ text, imageClass }: { text: React.ReactNode; imageClass: string }) => {
  return (
    <div className={style['card-desktop']}>
      <div className={clsx(style['item-image'], style[`${imageClass}-desktop`])} />
      <UIText1 color="text-inverted-default" fontWeight="700">
        {text}
      </UIText1>
    </div>
  );
};

export const HelpYouSell: React.FC<THelpYouSellProps> = ({ device, onOpenModal }) => {
  const handleOpenQualityCriteriaModal = () => {
    onOpenModal(EModalSource.QualityCriteria);
  };

  const UTP = getUTP(handleOpenQualityCriteriaModal);

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['wrapper']}>
        <div className={style['top']}>
          <div className={style['name']}>Циан.Сделка </div>
          <div className={style['title']}>Продайте недвижимость выгодно и&nbsp;спокойно</div>
          <div className={style['btn-container']}>
            <Button
              theme="fill_white_primary"
              size="L"
              onClick={() => onOpenModal(EModalSource.Consultation)}
              fullWidth
            >
              Получить консультацию
            </Button>
          </div>
          <div className={style['cards-desktop']}>
            {UTP.map(i => (
              <CardDesktop imageClass={i.imageClass} text={i.title} key={i.imageClass} />
            ))}
          </div>
        </div>
        <div className={style['bottom']}>
          <div className={style['cards-mobile']}>
            {UTP.map(i => (
              <CardMobile imageClass={i.imageClass} text={i.title} key={i.imageClass} />
            ))}
          </div>

          <div className={style['btn-container-bottom']}>
            <Button
              theme="fill_white_primary"
              size="L"
              onClick={() => onOpenModal(EModalSource.Consultation)}
              fullWidth
            >
              Получить консультацию
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
